/**
 * Check if a plan has tasks
 */
export const hasPlanTasks = (
  patientCPP:
    | mumms.patientCarePlanProblem
    | mumms.carePlanProblem
    | mumms.CPPEntity,
) => !!patientCPP?.numtasks && Number(patientCPP?.numtasks) > 0;
